module.exports = __webpack_public_path__ + "static/media/ic_update_package.4aed295c.svg";